/**
 * 解析题目 optionsJson，兼容旧/新格式；保留纯图片选项（截图选项等）
 */
function stripPlainText(html) {
  return String(html || '')
    .replace(/<br\s*\/?>/gi, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/<[^>]+>/g, '')
    .trim()
}

function isKeyOnlyOption(key, value) {
  const k = String(key || '').trim()
  if (!/^[A-Ha-h]$/.test(k)) return false
  const html = String(value || '')
  if (/<img\b/i.test(html)) return false
  const text = stripPlainText(html)
  return !text || text.toUpperCase() === k.toUpperCase()
}

export function parseQuestionOptions(optionsJson) {
  try {
    if (!optionsJson) return []
    const opts = JSON.parse(optionsJson)
    if (!Array.isArray(opts) || !opts.length) return []

    let list
    if (typeof opts[0] === 'string') {
      list = opts.map((str, i) => {
        const fallbackKey = String.fromCharCode(65 + i)
        const text = String(str)
        const match = text.match(/^([A-H])([.、]\s*(.*))?$/s)
        if (match) {
          const key = match[1]
          const rest = (match[3] || '').trim()
          return { key, value: rest || text }
        }
        return { key: text.charAt(0) || fallbackKey, value: text }
      })
    } else if (opts[0] && opts[0].key != null && opts[0].value !== undefined) {
      list = opts.map((opt) => ({ key: opt.key, value: opt.value }))
    } else {
      list = opts.map((item, i) => {
        const key = String.fromCharCode(65 + i)
        if (typeof item === 'string') {
          return { key, value: item.replace(/^[A-H][.、]\s*/, '') }
        }
        return { key: item.key || key, value: item.value != null ? item.value : '' }
      })
    }

    return list.filter((opt) => {
      const key = String(opt.key || '').trim()
      if (!key) return false
      const html = String(opt.value || '')
      if (/<img\b/i.test(html)) return true
      if (isKeyOnlyOption(key, html)) return true
      const text = stripPlainText(html)
      if (!text) return false
      return text.toUpperCase() !== key.toUpperCase()
    })
  } catch (e) {
    return []
  }
}
